import { Component, HostListener, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { IdleService } from './services/idle.service';
import { distinctUntilChanged, Subscription } from 'rxjs';
import { InsightsUtility } from './utilities/insights/insights.utility';
import { PageViewEvent } from './insights/events/page-view.event';
import { UserConfigsService } from './services/user-configs.service';
import { ApplicationStopEvent } from './insights/events/application-stop.event';
import { NotificationHubSdk } from 'src/app/sdks/notification.hub-sdk';
import { LexbeThemeService } from '@services/lexbe-theme.service';
import { Store } from '@ngrx/store';
import { AppActions } from '@store/app.actions';
import { switchMap, tap } from "rxjs/operators";
import { CaseHubSdk } from "@sdks/case.hub-sdk";
import { globalActions } from "@store/global/global.actions";

@Component({
    selector: 'lex-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
	@HostListener('window:beforeunload', ['$event'])
	public onWindowUnload() {
		this.insightsUtility.event(new ApplicationStopEvent());
	}

	public subscription: Subscription = new Subscription();

	constructor(
		public notificationHubSdk: NotificationHubSdk,
		private idleService: IdleService,
		private router: Router,
		private insightsUtility: InsightsUtility,
		private userConfigService: UserConfigsService,
		private renderer: Renderer2,
		private themeService: LexbeThemeService,
		private store: Store,
		private caseHubSdk: CaseHubSdk
	) {
		let themeSetting: 'light-theme' | 'dark-theme' = 'light-theme';
		if (this.themeService.isDarkMode()) {
			this.renderer.addClass(document.body, 'dark-theme');
			themeSetting = 'dark-theme';
		}
		let docViewerVersion: '2.0' | '3.0' = '3.0'
		if (sessionStorage['useNewDocViewer'] && sessionStorage['useNewDocViewer'] === 'false') {
			docViewerVersion = '2.0';
		}
		this.store.dispatch(AppActions.started());
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				this.insightsUtility.event(new PageViewEvent({page: event.url}));
			}
		});
		this.subscription.add(
			this.userConfigService.getUserConfigs().subscribe((config) => {
				this.insightsUtility.updateTelemetryContext({
					userId: config.userId,
					userEmail: config.userName,
					caseId: config.currentCase.caseId,
					accountId: config.currentCase.accountId,
					themeSetting: themeSetting,
					docViewerVersion: docViewerVersion
				});
			}));

		this.userConfigService.getUserConfigs().pipe(
			distinctUntilChanged((a, b) => a.currentCase.caseId === b.currentCase.caseId),
			switchMap(() =>
				this.caseHubSdk.processing$.pipe(
					tap(processing => {
						this.store.dispatch(globalActions.loadedProcessing({processing}));
					}),
				)
			)).subscribe();
	}

	ngOnInit(): void {
		this.idleService.watch();
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
